// Bangladesh divisions & phone normalization used by workshop intake forms
export const BD_DIVISIONS = [
  { key: "dhaka", en: "Dhaka", bn: "ঢাকা" },
  { key: "chattogram", en: "Chattogram", bn: "চট্টগ্রাম" },
  { key: "khulna", en: "Khulna", bn: "খুলনা" },
  { key: "rajshahi", en: "Rajshahi", bn: "রাজশাহী" },
  { key: "sylhet", en: "Sylhet", bn: "সিলেট" },
  { key: "barishal", en: "Barishal", bn: "বরিশাল" },
  { key: "rangpur", en: "Rangpur", bn: "রংপুর" },
  { key: "mymensingh", en: "Mymensingh", bn: "ময়মনসিংহ" },
] as const;

export type BdDivisionKey = (typeof BD_DIVISIONS)[number]["key"];

export function isBdDivision(v: unknown): v is BdDivisionKey {
  return typeof v === "string" && BD_DIVISIONS.some((d) => d.key === v);
}

/**
 * Normalize a Bangladeshi phone number to +8801XXXXXXXXX (E.164).
 * Accepts: 01XXXXXXXXX, 8801XXXXXXXXX, +8801XXXXXXXXX, with spaces/dashes.
 * Returns null when the input cannot be interpreted as a BD mobile number.
 */
export function normalizeBdPhone(input: string): string | null {
  if (!input) return null;
  const digits = input.replace(/[^\d]/g, "");
  let core: string | null = null;
  if (/^01[3-9]\d{8}$/.test(digits))
    core = digits; // 01XXXXXXXXX
  else if (/^8801[3-9]\d{8}$/.test(digits)) core = digits.slice(2);
  else if (/^\+8801[3-9]\d{8}$/.test(input.replace(/[\s-]/g, ""))) core = digits.slice(2);
  if (!core) return null;
  return "+880" + core.slice(1);
}
